// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
var Host = function (x) {
    return x;
};
var runHost = function (v) {
    return Control_Monad_Cleanup.runCleanupT(Effect_Class.monadEffectEffect)(v);
};
var monadHost = Control_Monad_Cleanup.monadCleanupT(Effect.monadEffect);
var monadEffectHost = Control_Monad_Cleanup.monadEffectCleanupT(Effect_Class.monadEffectEffect);
var monadCleanupHost = Control_Monad_Cleanup.monadCleanupCleanupT(Effect_Class.monadEffectEffect);
var liftHost = function (dictMonadCleanup) {
    return function (dictMonadEffect) {
        return function (m) {
            return Control_Bind.bind((dictMonadCleanup.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(runHost(m)))(function (v) {
                return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadCleanup.Monad0()).Bind1())(Control_Monad_Cleanup.onCleanup(dictMonadCleanup)(v.value1))(function () {
                    return Control_Applicative.pure((dictMonadCleanup.Monad0()).Applicative0())(v.value0);
                });
            });
        };
    };
};
var functorHost = Control_Monad_Cleanup.functorCleanupT(Effect.functorEffect);
var bindHost = Control_Monad_Cleanup.bindCleanupT(Effect.bindEffect);
var applyHost = Control_Monad_Cleanup.applyCleanupT(Effect.applyEffect);
var applicativeHost = Control_Monad_Cleanup.applicativeCleanupT(Effect.applicativeEffect);
var monadReplaceHost = {
    newSlot: Control_Bind.bind(bindHost)(Effect_Class.liftEffect(monadEffectHost)(Effect_Ref["new"]([  ])))(function (cleanupsRef) {
        var destroy = function __do() {
            var cleanups = Effect_Ref.read(cleanupsRef)();
            Effect_Ref.write([  ])(cleanupsRef)();
            return Data_Foldable.sequence_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(cleanups)();
        };
        var append$prime = function (m) {
            return function __do() {
                var v = runHost(m)();
                Effect_Ref.modify_(function (v1) {
                    return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v1)([ v.value1 ]);
                })(cleanupsRef)();
                return v.value0;
            };
        };
        return Control_Bind.discard(Control_Bind.discardUnit)(bindHost)(Control_Monad_Cleanup.onCleanup(monadCleanupHost)(destroy))(function () {
            return Control_Applicative.pure(applicativeHost)(new Control_Monad_Replace.Slot(function (m) {
                return function __do() {
                    destroy();
                    return append$prime(m)();
                };
            }, destroy, append$prime(Control_Monad_Replace.newSlot(monadReplaceHost))));
        });
    }),
    Monad0: function () {
        return monadHost;
    },
    MonadCleanup1: function () {
        return monadCleanupHost;
    }
};
export {
    Host,
    runHost,
    liftHost,
    functorHost,
    applyHost,
    applicativeHost,
    bindHost,
    monadHost,
    monadEffectHost,
    monadCleanupHost,
    monadReplaceHost
};
//# sourceMappingURL=index.js.map
